import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import TaskInput from "TaskDialogCommon/TaskInput";
import RunButton from "TaskDialogCommon/RunButton";
import StringList from "TaskDialogCommon/StringList";
import Instruction from "TaskDialogCommon/Instruction";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "chestopen";

const getInitialStatFromLastConfig = (accountdetailrow) => {
  const taskConfig = {
    accountdetail: accountdetailrow,
    chestsToOpenAtOnce: "10000",
    userInputIncludeChestNames: [],
    userInputExcludeChestNames: [],
  };
  try {
    var storeddata = getLastConfigForTask(taskname);
    if (storeddata) {
      var paramNames = [
        "chestsToOpenAtOnce",
        "userInputIncludeChestNames",
        "userInputExcludeChestNames",
      ];
      for (var i = 0; i < paramNames.length; i++) {
        var paramName = paramNames[i];
        if (storeddata[paramName]) {
          taskConfig[paramName] = storeddata[paramName];
        }
      }
    }
  } catch (e) {
    logger.log(e);
  }
  return taskConfig;
};

export default (props) => {
  const { accountdetailrow } = props;
  const [taskConfig, setTaskConfig] = React.useState(
    getInitialStatFromLastConfig(accountdetailrow)
  );

  logger.log("Here", props, taskConfig);

  const setValue = (event, key) => {
    let value = event.target.value;
    setTaskConfig({ ...taskConfig, [key]: value });
  };

  return (
    <TaskDialog heading={"Chest Open"}>
      <div>
        Advanced Options Below (DO NOT change if you are unsure about what they
        do)
      </div>

      <TaskInput
        label={"Open these many chests at a time"}
        value={taskConfig.chestsToOpenAtOnce}
        onChange={(event) => setValue(event, "chestsToOpenAtOnce")}
      />

      <StringList
        label={"DO NOT Open Chests Containing following words in their Names:"}
        taskConfig={taskConfig}
        param={"userInputExcludeChestNames"}
        itemAlias={"Chest"}
        setValue={setValue}
        instructions={
          "*Example 'Monday' will exclude all 'Monday Mystery' chests and other chests having 'Monday' in their names. *Entering whole name exactly as it is will also work *Words are not case-sensitive, so 'monday' will make chest having 'Monday' to count. *Exclude clause takes precedence over include."
        }
      />

      <StringList
        label={"Open Only Chest Containing Following Names:"}
        taskConfig={taskConfig}
        param={"userInputIncludeChestNames"}
        itemAlias={"Chest"}
        setValue={setValue}
        instructions={
          "*Example 'Monday' will include all 'Monday Mystery' chests and other chests having 'Monday' in their names. *Entering whole name exactly as it is will also work *Words are not case-sensitive, so 'monday' will make chest having 'Monday' to count. *Exclude clause takes precedence over include."
        }
      />

      <Instruction>
        1) Will not open Galadriel token chests or Chests whose Description says
        they contain Galadriels Token Chests
      </Instruction>

      <RunButton
        taskname={taskname}
        taskConfig={taskConfig}
        label={"Open Chests"}
      />
    </TaskDialog>
  );
};
